import { actionCreator } from '@/utils/redux';

import { AnyTransactionPeriod, NAMESPACE, Transaction, Wallet, WalletId } from './types';

const creator = actionCreator(NAMESPACE);

export interface SelectWalletActionPayload {
  id: string;
}

export interface RequestTransactionsActionPayload {}

export interface StoreTransactionsActionPayload extends RequestTransactionsActionPayload {
  lastPage: number;
  hasMore: boolean;
  data: Transaction[];
}

export interface ReloadBalanceActionPayload {
  force?: boolean;
}

export interface ReloadTransactionsActionPayload {
  force?: boolean;
}

export interface StoreLastReloadActionPayload {
  type: 'balance' | 'transactions';
  value: Date;
}

export interface StoreWalletsActionPayload {
  selected?: WalletId;
  all: Wallet[];
}

export interface StoreInitActionPayload {
  wallets: StoreWalletsActionPayload;
}

// sagas
export const init = creator.asyncAction<void>('INIT');
export const requestTransactions = creator.asyncActionWithPayload<RequestTransactionsActionPayload, void>(
  'REQUEST_TRANSACTIONS',
);
export const reloadBalance = creator.asyncActionWithPayload<ReloadBalanceActionPayload, void>('RELOAD_BALANCE');
export const reloadTransactions = creator.asyncActionWithPayload<ReloadTransactionsActionPayload, void>(
  'RELOAD_TRANSACTIONS',
);

// reducers
export const storeInitialized = creator.syncActionWithPayload<StoreInitActionPayload>('STORE_INIT');
export const storeTransactionsFilter = creator.syncActionWithPayload<AnyTransactionPeriod>('STORE_FILTER');
export const storeTransactions = creator.syncActionWithPayload<StoreTransactionsActionPayload>('STORE_TRANSACTIONS');
export const storeWallets = creator.syncActionWithPayload<StoreWalletsActionPayload>('STORE_WALLETS');
export const storeClearTransactions = creator.syncAction('STORE_CLEAR_TRANSACTIONS');
export const storeLastReload = creator.syncActionWithPayload<StoreLastReloadActionPayload>('STORE_LAST_RELOAD');
export const storeLogout = creator.syncAction('STORE_LOGOUT');

// notifications
export const notifyInitializationFinished = creator.syncAction('INIT_FINISHED');

export default {
  init,
  requestTransactions,
  reloadBalance,
  reloadTransactions,
  storeInitialized,
  storeTransactionsFilter,
  storeClearTransactions,
  storeTransactions,
  storeLastReload,
  storeLogout,
  notifyInitializationFinished,
};
